
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/educators/[[...slug]]",
      function () {
        return require("private-next-pages/educators/[[...slug]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/educators/[[...slug]]"])
      });
    }
  